//when finished loading, get all span tags with class wow-text and wrap them in a div with class wow-text-container
window.addEventListener("load", function () {
    wowText();
});

//add an event listener to the window to check if the wow-text element is visible
window.addEventListener("scroll", function () {
    wowText();
});

function isElementVisible(element) {
    var rect = element.getBoundingClientRect();
    var viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight,
    );
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

function wowText() {
    let wowText = document.querySelectorAll("span.wow-text");
    wowText.forEach(function (element) {
        // Check if the element is visible
        if (isElementVisible(element)) {
            // Get the inner value of the wowText element
            var innerValue = element.innerText;

            // Get the width and height of the wowText element
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            // Convert element to SVG text
            var svgElement = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "svg",
            );
            svgElement.setAttribute("width", width);
            svgElement.setAttribute("height", height);
            var textElement = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "text",
            );
            textElement.textContent = innerValue;

            // Set the position of the text to bottom of the svg element
            textElement.setAttribute("x", 0);
            textElement.setAttribute("y", height);

            let textHeight = textElement.getBBox().height;
            let diff = height - textHeight;
            svgElement.setAttribute("style", "margin-top: -" + diff + "px");

            svgElement.appendChild(textElement);
            //add class wow-text to svgElement
            svgElement.classList.add("wow-text");
            element.parentNode.replaceChild(svgElement, element);

            // Animate outline
            let outlineAnimation = svgElement.animate(
                [
                    { strokeDasharray: "100%", strokeDashoffset: "100%" },
                    { strokeDasharray: "100%", strokeDashoffset: "0%" },
                ],
                {
                    duration: 1500,
                    easing: "linear",
                },
            );

            // Animate fill
            let fillAnimation = svgElement.animate(
                [
                    { fillOpacity: 0, strokeWidth: 1 },
                    { fillOpacity: 1, strokeWidth: 0 },
                ],
                {
                    duration: 1000,
                    delay: 1000,
                    easing: "linear",
                    //keep it there
                    fill: "forwards",
                },
            );

            //slight bounce animation
            let bounceAnimation = svgElement.animate(
                [
                    { transform: "scale(1)" },
                    { transform: "scale(1.05)" },
                    { transform: "scale(1)" },
                ],
                {
                    duration: 1000,
                    delay: 1000,
                    easing: "ease-in-out",
                    iterations: 1,
                },
            );
        }
    });
}

// Throttle function
function throttleSVGTransition(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(
                function () {
                    if (Date.now() - lastRan >= limit) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                },
                limit - (Date.now() - lastRan),
            );
        }
    };
}

// Resize event handler
function handleResize() {
    const wowTextElements = document.querySelectorAll("svg.wow-text");
    wowTextElements.forEach((element) => {
        const innerValue = element.firstChild.textContent;
        const spanElement = document.createElement("span");
        spanElement.textContent = innerValue;
        spanElement.style.color = "var(--wp--preset--color--accent)";

        element.parentNode.replaceChild(spanElement, element);
    });
}

// Attach throttled resize event handler
window.addEventListener("resize", throttleSVGTransition(handleResize, 250));
